export function gotoChallenge() {
  const path = (location.pathname + location.search).substring(1);
  window.location.href = 'https://employer.snagajob.com/challenge?to=' + path;
}
